<template>
  <div class="w100">
    <div class="mar-left"
         :style="`width:${300*$store.state.ratio.hole}px;height:${80*$store.state.ratio.hole}px;margin-left:${2*$store.state.ratio.width}px`">
      <div class="mar"
           :style="`margin-left:${marginLeft}`">
           {{this.copyData}}
        <!-- <div v-for='(item,index) in copyData'
             class=" test-c"
             :key='index'
             :style="`width:${40*$store.state.ratio.hole}px;height:${60*$store.state.ratio.hole}px;margin-top:${10*$store.state.ratio.hole}px;margin-left:${10*$store.state.ratio.hole}px
             ;line-height:${60*$store.state.ratio.hole}px;font-size:${16*$store.state.ratio.hole}px`">{{item}}</div> -->
      </div>
    </div>

  </div>
</template>
<script>
export default {
  props: ['data'],
  data () {
    return {
      marginLeft: '',
      copyData: ''
    }
  },
  mounted () {
    this.initNum()
  },
  watch: {
    data: {
      handler: function () {
        this.initNum()
      }

    },
  },
  methods: {
    initNum () {
      // let arr = []
      this.copyData = this.data || '0'
      // if (typeof this.copyData == 'string') {
      //   this.copyData.split('').forEach(item => {
      //     arr.push(parseInt(item))
      //   })
      //   this.copyData = arr || []

      //   let n = this.copyData.length;

      //   this.marginLeft = (240 - 55 * n - 10) / 2 * this.$store.state.ratio.hole + 'px'
      // }

    }



  }
}
</script>
<style lang="scss" scoped>
.w100 {
  width: 100%;
  display: flex;
 justify-content: center;
 align-items: center;
}
.test-c {
  text-align: center;
  background: #2346a2;
  display: inline-block;
}
.mar{
 display: flex;
 justify-content: center;
 align-items: center;
 font-size: 42px;
 font-weight: 600;
}
</style>